firebird.factory('videoLayoutReuseService', [
    '$timeout',
    '$window',
    'logService',
    'helperService',
    'configService',
    'attendeeListService',
    'videoGlobalService',
    function ($timeout, $window, logService, helperService, configService, attendeeListService, videoGlobalService) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoLayoutReuseService');

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.initLayoutReuse = initLayoutReuse;

            // Logic to decouple remoteFeed from underlying peer connection, and allow switching peerconnection for page nagivation case.
            // For subscriber, the create function is used which returns a wrapper to plugin on success. Later, when videos are to be
            // changed (visible to hidden and vice-versa) the change function is called to assign a peer connection to visible from hidden
            // video. Note that the wrapper is used only when layoutPage AND layoutPageReuse.enabled is true, AND is not used for screen.
            // If a pending operation exists on the plugin, or no new available plugin is found, then it is not re-assigned, and new one
            // is created for the wrapper.

            // following are external functions to be called from elsewhere.
            self.onLayoutPageSubscriberCreate = onLayoutPageSubscriberCreate;
            self.onLayoutPageSubscriberChange = onLayoutPageSubscriberChange;
            self.onLayoutPageSubscriberRemoveAll = onLayoutPageSubscriberRemoveAll;

            // following are internal functions to be called from above external functions.
            self.layoutPageCreateWrapper = layoutPageCreateWrapper;
            self.onLayoutReuseUpdateCutoff = onLayoutReuseUpdateCutoff;
            self.layoutPageSubscriberAttach = layoutPageSubscriberAttach;
            self.layoutPageIncrementPending = layoutPageIncrementPending;
            self.layoutPageDecrementPending = layoutPageDecrementPending;
            self.layoutPageFindWrapper = layoutPageFindWrapper;
            self.layoutPageRemoveWrapper = layoutPageRemoveWrapper;
            self.layoutPageRemovePlugin = layoutPageRemovePlugin;
            self.layoutPageSubscriberSwitch = layoutPageSubscriberSwitch;
            self.layoutPageResetSrcObjectIfNeeded = layoutPageResetSrcObjectIfNeeded;
            self.layoutPageCancelResetSrcObject = layoutPageCancelResetSrcObject;
            self.layoutPageTimeoutWithState = layoutPageTimeoutWithState;
            self.layoutPageTimeoutCancelWithState = layoutPageTimeoutCancelWithState;
            self.layoutPageVideoMuteUnmuteListener = layoutPageVideoMuteUnmuteListener;
            self.layoutPagePendingTimerStart = layoutPagePendingTimerStart;
            self.layoutPagePendingTimerStop = layoutPagePendingTimerStop;
            self.layoutPagePendingTimerHandler = layoutPagePendingTimerHandler;
            self.onLayoutPageUpdateComplete = onLayoutPageUpdateComplete;
            self.layoutPageVerifyInvariants = layoutPageVerifyInvariants;
            self.getLayoutPageState = getLayoutPageState;

            self.layoutPageReuse = {
                enabled: false, // flag to enable/disable this feature.
                max: 30, // at most 30 plugins allowed (only webcams; not is_screen). this is not used actually.
                count: 0, // current count in plugins that are created, AND not in plugins that are pending create.
                enableWrapper: false, // if count reaches max, it enables this, for duration of call.
                plugins: [], // list of at most max plugins. plugin has array of id values.
                wrappers: [], // list of wrappers to plugins.
                pendingCount: 0, // pending calls for various plugins. sum of all plugins' _pendingCount values.
                pendingStart: 0, // number of wrappers that have not started yet. If positive, it blocks new attach, and adds to pendingCreate.
                pendingStartId: [], // list of pendingId that are counted in pendingStart. May represent duplicate fid. Used only for diagnostic purpose.
                pendingCreate: [], // list of pending fake attach that are not served until all pending plugins are cleared.
                pendingTimeout: null, // timer for waiting for pendingStart to become 0.
                pendingWaitTime: 20000, // max timeout in ms to wait for pendingStart to become 0, after last request.
                pendingSwitchTime: 4000 // max time in ms for switch to respond, after switch video is turned black if still pending.
            };

            if (helperService.getQueryParameter('layoutReuseWaitTime')) {
                // for experimental debugging and testing.
                self.layoutPageReuse.pendingWaitTime =
                    parseInt(helperService.getQueryParameter('layoutReuseWaitTime')) || 20000;
            }

            if (helperService.getQueryParameter('pendingSwitchDelayTime')) {
                // for experimental debugging and testing, together with pendingSwitchTime.
                self.layoutPageReuse.pendingSwitchDelayTime = parseInt(
                    helperService.getQueryParameter('pendingSwitchDelayTime')
                );
            }

            // additionally, a callbacks or plugin object can have a _pendingCount attribute, and
            // callbacks may have _pendingStart (boolean), and if present, then counted in pendingStart above.
            // This _pendingStart is set (true) before attach, and is deleted when callbacks AND associated plugin reach _pendingCount of 0 first time.

            // these are used for generating wrapper and plugin id, which are used for logging.
            self.lastWrapperId = 0;
            self.lastPluginId = 0;

            self.layoutPageUpdateTimeout = null;
            self.layoutPageUpdateAfter = 10000; // check 10s after updateVideosLayout.
        }

        // update from config
        function initLayoutReuse() {
            self.layoutPageReuse.enabled =
                helperService.getEnvironment() === 'prod' ? true : configService.getValue('layoutPageReuse') == 'true';
        }

        // There are three objects for each subscriber - wrapper, plugin and callbacks.
        // The callbacks is what is supplied by the caller. The plugin is what is returned by janus.attach on success.
        // and wrapper is a wrapper around plugin+callbacks, which is returned by this function on success.
        // Internally, the code has a one to one mapping between wrapper and callbacks supplied to this function.
        // And a one-to-one mapping between plugin and callbacks associated with that plugin's attach call.
        // Furthermore, a wrapper may or may not be associated with a plugin. In which case an optional one-to-one
        // mapping exists between a wrapper and a plugin object.

        // Params: options has fid and is_screen. callbacks is the object supplied to janus.attach().

        function onLayoutPageSubscriberCreate(callbacks, options) {
            if (!self.layoutPage || !self.layoutPageReuse.enabled || (options && options.is_screen)) {
                if (!self.janus) {
                    logger.error('onLayoutPageSubscriberCreate', 'attach during reconnect is ignored for non wrapper.');
                    return;
                }

                return self.janus.attach(callbacks); // fallback if not enabled or applicable.
            }

            var data = self.layoutPageData;
            var data1 = self.layoutPageReuse;

            self.logLayout(
                'request to attach, fid=' +
                    options.fid +
                    ', existing=' +
                    data1.wrappers.length +
                    ' plugins=' +
                    data1.count
            );

            wrapper = self.layoutPageCreateWrapper(callbacks, options);

            var visible = (data.videos[options.fid] || {}).visible; // true, false, undefined.
            var max = Math.max(data.cutoff, data.pageSize);
            let div = $window.$('#videoroom-videos > div.remote[user="' + options.fid + '"]')[0];
            // There could be destroyJanus called before (for example when turn on/off E2EE) and in case of self.layoutPage is true all subscribers were removed.
            // So we need to subscribe to plugin when video is in paused state (div.isPaused).
            // Otherwise there could be black screen when unpause videos, because we'll not be able to send a message 'start' to Janus (see details in ANYAM-84700).
            if ((visible !== false && data1.count < max) || visible === true || (div && div.isPaused)) {
                // create new plugin. use visible if set.
                self.logLayout(
                    'doing actual subscriber attach count=' + data1.count + ' max=' + max + ' or visible=' + visible
                );
                self.layoutPageSubscriberAttach(wrapper);
            } else {
                // without the real plugin
                if (data1.pendingStart > 0) {
                    self.logLayout('putting the request as pending, fid=' + wrapper._fid);
                    data1.pendingCreate.push(wrapper);
                    self.layoutPagePendingTimerStart();
                } else {
                    self.logLayout('responding with fake success, fid=' + wrapper._fid);
                    wrapper._callbacks.success(wrapper);
                }
            }

            return wrapper;
        }

        function layoutPageCreateWrapper(callbacks, options) {
            var data1 = self.layoutPageReuse;

            var wrapper = {
                _plugin: null,
                _fid: options.fid,
                _feed: null,
                _room: null,
                _callbacks: callbacks // original object is stored for callback on this wrapper.
            };

            callbacks._pendingId = 'W' + ++self.lastWrapperId;

            callbacks._fid = options.fid;

            data1.wrappers.push(wrapper);

            wrapper.send = function (msg) {
                self.logLayout('wrapper send ' + wrapper._fid + ' ' + JSON.stringify(msg));
                var message = msg.message || {};

                if (message.request == 'join' && message.feed && message.room) {
                    wrapper._feed = message.feed;
                    wrapper._room = message.room;
                }
                if (wrapper._plugin) {
                    if (
                        message.request == 'join' ||
                        message.request == 'start' ||
                        message.request == 'pause' ||
                        message.request == 'switch'
                        // || message.request == 'configure'
                    ) {
                        self.logLayout('calling layoutPageIncrementPending from layoutPageCreateWrapper->send');
                        if (message.request == 'switch') {
                            wrapper._plugin._pendingSwitch = true;
                            var fid = wrapper._fid,
                                plugin = wrapper._plugin;
                            var pendingSwitchTimerHandler = function () {
                                // if switch does not succeed soon, stop the video.
                                delete plugin._pendingSwitchTimeout;
                                var data = self.layoutPageData;
                                var div = (data.videos[fid] || {}).div;
                                if (div) {
                                    logService.log(
                                        'videoroomCtrl - switch timedout, saving stream, and turning video black, fid=' +
                                            fid
                                    );
                                    plugin._pendingSwitchStream = div.querySelector('video').srcObject;
                                    div.querySelector('video').srcObject = null; // makes it black.
                                } else {
                                    logService.log('videoroomCtrl - switch timedout, but no video found, fid=' + fid);
                                }
                            };

                            if (self.isCompactMode) {
                                pendingSwitchTimerHandler();
                            } else {
                                wrapper._plugin._pendingSwitchTimeout = $timeout(
                                    pendingSwitchTimerHandler,
                                    data1.pendingSwitchTime
                                );
                            }
                        }
                        self.layoutPageIncrementPending(wrapper._plugin); // decrement onmessage attached, started, configured or error.
                    }
                    if (wrapper.detaching && message.request == 'configure') {
                        self.logLayout('ignore configure when plugin is detaching');
                    } else {
                        // keep this code for testing purpose. simulate delay in certain requests.
                        if (
                            self.layoutPageData.wrapperDelay &&
                            (message.request == 'switch' || message.request == 'start' || message.request == 'pause')
                        ) {
                            var sender = wrapper._plugin.send.bind(wrapper._plugin);
                            setTimeout(function () {
                                sender(msg);
                            }, Math.round(Math.random() * 10000));
                        } else {
                            return wrapper._plugin.send(msg);
                        }
                    }
                } else {
                    if (message.request == 'join' && message.feed) {
                        self.logLayout('faking join success as no plugin attached');
                        var display = (attendeeListService.findAttendee(message.feed) || {}).screenName; // TODO: need a better way here so that display name comes from Janus.
                        wrapper._callbacks.onmessage({
                            videoroom: 'attached',
                            room: message.room,
                            id: message.feed,
                            display: display
                        });
                        wrapper.state.call = 'started'; // similar to createAnswer success.
                        wrapper.state.webrtc = true;
                        wrapper.state.ice = 'connected';
                        wrapper._callbacks.onmessage({ videoroom: 'event', room: message.room, started: 'ok' });
                        // wrapper.layoutHidden = true; // no plugin, must be hidden to start with.
                        wrapper._callbacks.onremotestream(null);
                    } else if (message.request == 'configure') {
                        self.logLayout('faking configure success as no plugin attached');
                        wrapper._callbacks.onmessage({ videoroom: 'event', room: wrapper._room, configured: 'ok' });
                    } else {
                        logger.error(
                            'layoutPageCreateWrapper',
                            'send called, but plugin is not attached to wrapper',
                            wrapper._fid,
                            msg
                        );
                    }
                }
            };
            wrapper.getPlugin = function () {
                return callbacks.plugin;
            };
            wrapper.getId = function () {
                return wrapper._plugin ? wrapper._plugin.getId() : null;
            };
            wrapper.createAnswer = function (arg) {
                if (wrapper._plugin) {
                    var callbacks = wrapper._callbacks;
                    self.logLayout('calling layoutPageIncrementPending from layoutPageCreateWrapper->createAnswer');
                    self.layoutPageIncrementPending(callbacks);
                    var plugin = wrapper._plugin;
                    return wrapper._plugin.createAnswer(
                        Object.assign({}, arg, {
                            success: function (jsep) {
                                arg.success(jsep);
                                self.logLayout(
                                    'calling layoutPageDecrementPending from createAnswer->success callback'
                                );
                                self.layoutPageDecrementPending(callbacks, { plugin: plugin });
                            },
                            error: function (error) {
                                arg.error(error);
                                self.logLayout('calling layoutPageDecrementPending from createAnswer->error callback');
                                self.layoutPageDecrementPending(callbacks, { plugin: plugin });
                            }
                        })
                    );
                } else {
                    logger.error(
                        'layoutPageCreateWrapper',
                        'createAnswer called when plugin is not attached to wrapper',
                        wrapper._fid
                    );
                }
            };
            wrapper.detach = function (arg) {
                self.logLayout('detach, fid=' + wrapper._fid + ', plugin=' + !!wrapper._plugin);
                wrapper._detachingTime = Date.now(); // another _ flag to avoid conflict with detaching or detached.
                var result;
                var callbacks = wrapper._callbacks;
                if (wrapper._plugin) {
                    result = wrapper._plugin.detach(arg); // this will call oncleanup internally.
                    self.logLayout('calling layoutPageDecrementPending from detach for plugin');
                    self.layoutPageDecrementPending(wrapper._plugin, { reset: true });
                    self.layoutPageRemovePlugin(wrapper._plugin);
                } else {
                    self.logLayout('detach called when plugin is not attached to wrapper, fid=' + wrapper._fid);
                    wrapper._callbacks.oncleanup();
                }
                self.layoutPageRemoveWrapper(wrapper);
                if (callbacks) {
                    self.logLayout('calling layoutPageDecrementPending from detach for wrapper');
                    self.layoutPageDecrementPending(callbacks, { reset: true, remove: true });
                }
                return result; // not used currently
            };

            Object.defineProperty(wrapper, 'webrtcStuff', {
                get: function () {
                    if (wrapper._plugin) {
                        return wrapper._plugin.webrtcStuff;
                    } else {
                        // logger.error('layoutPageCreateWrapper', 'webrtcStuff accessed when plugin is not attached to wrapper');
                        return null;
                    }
                }
            });

            return wrapper;
        }

        function onLayoutReuseUpdateCutoff() {
            var data = self.layoutPageData;
            var data1 = self.layoutPageReuse;

            var max = Math.max(data.cutoff, data.pageSize);
            if (data1.count >= max) {
                // if it reaches max, enable wrapper.
                data1.enableWrapper = true;
            }
        }

        function layoutPageSubscriberAttach(wrapper) {
            if (!self.janus) {
                logger.error('layoutPageSubscriberAttach', 'attach during reconnect is ignored', wrapper._fid);
                return;
            }

            var data = self.layoutPageData;
            var data1 = self.layoutPageReuse;
            var callbacks = {}; // state for storing plugin handle

            data1.count += 1; // number of plugins. pre-increment, to avoid over committing.
            self.onLayoutReuseUpdateCutoff();
            self.logLayout('calling layoutPageIncrementPending from layoutPageSubscriberAttach');
            self.layoutPageIncrementPending(wrapper._callbacks, true);

            var overides = {
                // overide all callbacks.
                success: function (pluginHandle) {
                    wrapper._plugin = callbacks._plugin = pluginHandle;
                    pluginHandle._pendingId = 'P' + ++self.lastPluginId;
                    pluginHandle._wrapper = wrapper; // current mapping, can change later.
                    data1.plugins.push(pluginHandle);
                    self.logLayout('responding with real success, fid=' + wrapper._fid);
                    var success = wrapper._callbacks.success;
                    success(wrapper);
                    self.logLayout('calling layoutPageDecrementPending from overrides->success callback');
                    self.layoutPageDecrementPending(wrapper._callbacks, { plugin: wrapper._plugin });
                },
                error: function (err) {
                    data1.count -= 1; // reduce plugins count.
                    // remove from wrappers list on error.
                    self.layoutPageRemoveWrapper(wrapper);
                    var error = wrapper._callbacks.error;
                    const errorHandled = error(err);
                    self.logLayout('calling layoutPageDecrementPending from overrides->error callback');
                    self.layoutPageDecrementPending(wrapper._callbacks, { reset: true, remove: true }); // reset.

                    return errorHandled;
                },

                // for all other handlers, map the callbacks to wrapper, to determine the right wrapper to use.
                // this is because the actual plugin on which these handlers are
                // called might be associated with another wrapper currently.

                onmessage: function (msg, jsep) {
                    if (data1.pendingSwitchDelayTime && msg.switched == 'ok' && !msg._done) {
                        // this code is used only for testing.
                        msg._done = true;
                        if (data1.pendingSwitchDelayTime > 0) {
                            logService.log('videoroomCtrl - postponing switch response for test');
                            $timeout(function () {
                                logService.log('videoroomCtrl - continuing switch response for test');
                                overides.onmessage(msg, jsep);
                            }, data1.pendingSwitchDelayTime);
                        }
                        return;
                    }

                    var wrapper = self.layoutPageFindWrapper(callbacks);
                    if (!wrapper) {
                        if (msg && (msg.configured || (msg.videoroom == 'event' && (msg.substream || msg.temporal)))) {
                            self.logLayout(
                                'ignoring configured when plugin wrapper is not found, has-plugin=' +
                                    !!callbacks._plugin
                            );
                        } else {
                            logger.warn(
                                'layoutPageSubscriberAttach',
                                `failed to map callbacks to wrapper for onmessage, has-plugin=${!!callbacks._plugin}`,
                                msg
                            );
                        }
                        return;
                    }

                    self.logLayout('wrapper received ' + wrapper._fid + ' ' + JSON.stringify(msg));

                    if (msg.error && wrapper._plugin && wrapper._plugin._pendingSwitch) {
                        // remove switch timer and stream if any.
                        if (wrapper._plugin._pendingSwitchTimeout) {
                            $timeout.cancel(wrapper._plugin._pendingSwitchTimeout);
                            delete wrapper._plugin._pendingSwitchTimeout;
                        }
                        if (wrapper._plugin._pendingSwitchStream) {
                            delete wrapper._plugin._pendingSwitchStream;
                        }
                    }

                    var onmessage = wrapper._callbacks.onmessage;
                    onmessage(msg, jsep);

                    // decrement pending on error, and on attached or started.
                    if (msg.error) {
                        if (wrapper._plugin) {
                            self.logLayout('calling layoutPageDecrementPending from onmessage-> error state');
                            self.layoutPageDecrementPending(wrapper._plugin, {
                                error: true,
                                callbacks: wrapper._callbacks
                            });

                            if (
                                wrapper._plugin._pendingSwitch &&
                                (msg.error_code == 437 || msg.error.indexOf('switch') > 0)
                            ) {
                                // if switch failed.
                                // start play for the fid asynchronously, instead of switch to new fid.
                                var fid0 = wrapper._fid;
                                self.logLayout('restarting video play for ' + fid0 + ' because switch failed');
                                $timeout(function () {
                                    self.msgflowEvent('play-restart:switch', {
                                        reason: 'after switch failed',
                                        id: fid0
                                    });
                                    self.restartVideoPlay(fid0);
                                });
                            }
                        } // else already cleaned up in oncleanup.
                    } else {
                        var event = msg.anymeeting || msg.videoroom || msg.sip;
                        if (
                            event == 'attached' ||
                            (event == 'event' && (msg.started || msg.paused || msg.switched))
                            //|| msg.configured
                        ) {
                            self.logLayout('calling layoutPageDecrementPending from onmessage-> event');
                            if (msg.switched && wrapper._plugin && wrapper._plugin._pendingSwitch) {
                                delete wrapper._plugin._pendingSwitch;
                                if (wrapper._plugin._pendingSwitchTimeout) {
                                    // playing.
                                    $timeout.cancel(wrapper._plugin._pendingSwitchTimeout);
                                    delete wrapper._plugin._pendingSwitchTimeout;
                                } else if (wrapper._plugin._pendingSwitchStream) {
                                    // probably paused
                                    var div = (data.videos[wrapper._fid] || {}).div;
                                    if (div) {
                                        logService.log(
                                            'videoroomCtrl - restoring stream, on switched, after timeout, fid=' +
                                                wrapper._fid
                                        );
                                        div.querySelector('video').srcObject = wrapper._plugin._pendingSwitchStream; // restore the stream.
                                    } else {
                                        logService.log(
                                            'videoroomCtrl - not div found, on switched, after timeout, fid=' +
                                                wrapper._fid
                                        );
                                    }
                                    delete wrapper._plugin._pendingSwitchStream;
                                }
                            }
                            self.layoutPageDecrementPending(wrapper._plugin, { callbacks: wrapper._callbacks });
                        }
                    }
                },

                oncleanup: function () {
                    var wrapper = self.layoutPageFindWrapper(callbacks);
                    if (wrapper) {
                        self.logLayout('wrapper oncleanup, fid=' + wrapper._fid + ', plugin=' + !!wrapper._plugin);
                        var oncleanup = wrapper._callbacks.oncleanup;
                        oncleanup();
                    } else {
                        logger.warn(
                            'layoutPageSubscriberAttach',
                            `failed to map callbacks to wrapper for oncleanup, has-plugin=${!!callbacks._plugin}`
                        );
                    }
                }
            };

            // these callbacks are generic handlers

            ['webrtcState', 'iceState', 'slowLink', 'onlocalstream', 'onremotestream', 'ondetached'].forEach(function (
                name
            ) {
                overides[name] = function () {
                    var wrapper = self.layoutPageFindWrapper(callbacks);
                    if (wrapper) {
                        self.logLayout(name + ' ' + wrapper._fid);
                        var handler = wrapper._callbacks[name];
                        handler.apply(null, arguments);
                    } else {
                        logger.warn(
                            'layoutPageSubscriberAttach',
                            `failed to map callbacks to wrapper for ${name}, has-plugin=${!!callbacks._plugin}`
                        );
                    }
                };
            });

            self.logLayout('attaching plugin, fid=' + wrapper._fid);

            return self.janus.attach(Object.assign({}, wrapper._callbacks, overides)); // shallow copy of data, and override all callbacks.
        }

        function layoutPageIncrementPending(callbacks, start) {
            var data1 = self.layoutPageReuse;

            if (start) {
                // mark the callbacks in pending start, and increment count.
                callbacks._pendingStart = true;
                data1.pendingStart += 1;
                data1.pendingStartId.push(callbacks._pendingId);
                self.logLayout('++pendingstart[' + callbacks._pendingId + '] = ' + data1.pendingStart);
            }

            data1.pendingCount += 1; // number or pending requests.
            callbacks._pendingCount = (callbacks._pendingCount || 0) + 1; // cleared on success or error.
            self.logLayout('++pending[' + callbacks._pendingId + '] = ' + data1.pendingCount);
        }

        // options can have reset: true, error: true, start: true
        function layoutPageDecrementPending(callbacks, options) {
            if (!callbacks) {
                self.logLayout('layoutPageDecrementPending called, but callbacks is not defined');
                return;
            }

            if (!options) {
                // should not happen ideally.
                options = {};
            }

            var reset = options.reset,
                error = options.error;

            var data = self.layoutPageData;
            var data1 = self.layoutPageReuse;

            // if arg is plugin, then this is associated wrapper callbacks object, otherwise it is supplied callbacks object.
            var callbacks1 = options.callbacks || ((options.remove || options.plugin) && callbacks) || null;

            var wasPending = callbacks1 && callbacks1._pendingStart;

            if (callbacks._pendingCount) {
                // may be undefined, 0, or positive number.
                if (reset) {
                    // reset pending on this callbacks object.
                    var oldPendingCount = data1.pendingCount;
                    data1.pendingCount = Math.max(0, data1.pendingCount - callbacks._pendingCount);
                    callbacks._pendingCount = 0;
                    self.logLayout(
                        'reset pending[' +
                            callbacks._pendingId +
                            '] = ' +
                            data1.pendingCount +
                            ' (previous ' +
                            oldPendingCount +
                            ')'
                    );
                } else {
                    if (callbacks._pendingCount > 0) {
                        callbacks._pendingCount -= 1;
                        data1.pendingCount = Math.max(0, data1.pendingCount - 1);
                        self.logLayout('--pending[' + callbacks._pendingId + '] = ' + data1.pendingCount);
                    } else {
                        logService.log(
                            'LAYOUT - invalid pendingCount on decrement pending[' +
                                callbacks._pendingId +
                                '] = ' +
                                callbacks._pendingCount
                        );
                    }
                }
            } else {
                if (!reset && !error) {
                    // this should not happen ideally.
                    logService.log(
                        'LAYOUT - layoutPageDecrementPending called when already 0, pending[' +
                            callbacks._pendingId +
                            ']'
                    );
                } else {
                    self.logLayout(
                        'layoutPageDecrementPending called for reset or error, but is zero pending[' +
                            callbacks._pendingId +
                            ']'
                    );
                }
            }

            // if previous was pending start, and now callbacks and plugin don't have any pendingCount, then reset pendingStart, and reduce counter.
            if (
                wasPending &&
                !callbacks._pendingCount &&
                callbacks1._pendingStart &&
                ((!options.plugin && options.remove) ||
                    !(
                        (options.plugin && options.plugin._pendingCount) ||
                        (options.callbacks && options.callbacks._pendingCount)
                    ))
            ) {
                delete callbacks1._pendingStart;
                data1.pendingStart -= 1;
                var index1 = data1.pendingStartId.indexOf(callbacks1._pendingId);
                if (index1 >= 0) {
                    data1.pendingStartId.splice(index1, 1);
                } else {
                    logger.error('layoutPageDecrementPending', 'not found in pendingStartId', callbacks1._pendingId);
                }

                self.logLayout('--pendingstart[' + callbacks1._pendingId + '] = ' + data1.pendingStart);
            }

            if (data1.pendingStart <= 0 && data1.pendingCreate.length > 0) {
                // no more pending start, respond to all pending attach requests.
                var isAttaching = false;
                while (!isAttaching && data1.pendingCreate.length > 0) {
                    var wrapper0 = data1.pendingCreate.shift();
                    if (data1.pendingCreate.length <= 0) {
                        self.layoutPagePendingTimerStop();
                    }
                    var visible = (data.videos[wrapper0._fid] || {}).visible; // true, false, undefined.
                    var max = Math.max(data.cutoff, data.pageSize);
                    if ((visible !== false && data1.count < max) || visible === true) {
                        // create plugin as there is room. use visible if set
                        self.logLayout(
                            'doing actual attach since count ' +
                                data1.count +
                                ' is smaller than max=' +
                                max +
                                ' or visible=' +
                                visible
                        );
                        self.msgflowEvent('play-attach:pending:' + wrapper0._fid, {
                            reason: 'after pending resolved',
                            id: wrapper0._fid
                        });
                        self.layoutPageSubscriberAttach(wrapper0);
                        isAttaching = true; // do not continue to next pending
                    } else {
                        self.logLayout('resolving pending fake attach for fid=' + wrapper0._fid);
                        var success = wrapper0._callbacks.success;
                        success(wrapper0);
                    }
                }
            }
        }

        // reverse map - callbacks to wrapper that is attached to same plugin.
        function layoutPageFindWrapper(callbacks) {
            if (callbacks._plugin && callbacks._plugin._wrapper) {
                return callbacks._plugin._wrapper;
            }
            return null;
        }

        function layoutPageRemoveWrapper(wrapper) {
            var data1 = self.layoutPageReuse;
            self.logLayout('removing wrapper for plugin ' + wrapper._fid);

            var index1 = data1.wrappers.indexOf(wrapper);
            if (index1 >= 0) {
                data1.wrappers.splice(index1, 1);
            } else {
                self.logLayout('not found in wrappers, not removed');
            }

            if (wrapper._plugin) {
                // disassociate wrapper and plugin, if any.
                var plugin = wrapper._plugin;
                if (plugin._wrapper === wrapper) {
                    plugin._wrapper = null;
                }
                wrapper._plugin = null;
            }
        }

        function layoutPageRemovePlugin(plugin) {
            var data1 = self.layoutPageReuse;
            self.logLayout('removing plugin and disassociating wrapper, id=' + plugin.rfid);

            var index = data1.plugins.indexOf(plugin);
            if (index >= 0) {
                data1.plugins.splice(index, 1);
                data1.count -= 1;
            } else {
                self.logLayout('not found in plugins, not removed');
            }

            if (plugin._wrapper) {
                // disassociate wrapper and plugin, if any.
                var wrapper = plugin._wrapper;
                if (wrapper._plugin === plugin) {
                    wrapper._plugin = null;
                }
                plugin._wrapper = null;
            }
            if (plugin._pendingSwitchTimeout) {
                $timeout.cancel(plugin._pendingSwitchTimeout);
                delete plugin._pendingSwitchTimeout;
            }
            if (plugin._pendingSwitchStream) {
                delete plugin._pendingSwitchStream;
            }
        }

        // this is force cleanup on janusDestroy. cleanup here too.
        function onLayoutPageSubscriberRemoveAll() {
            var data1 = self.layoutPageReuse;

            data1.count = 0;
            data1.pendingCount = 0;
            data1.pendingStart = 0;
            if (data1.pendingStartId.length > 0) {
                data1.pendingStartId.splice(0, data1.pendingStartId.length);
            }
            self.layoutPagePendingTimerStop();

            var wrappers = data1.wrappers.slice();
            data1.wrappers.splice(0, data1.wrappers.length);
            var plugins = data1.plugins.slice();
            data1.plugins.splice(0, data1.plugins.length);
            // remove references for garbage collection.
            wrappers.forEach(function (wrapper) {
                wrapper._plugin = null;
            });
            plugins.forEach(function (plugin) {
                plugin._wrapper = null;
            });

            if (self.layoutPageUpdateTimeout) {
                $timeout.cancel(self.layoutPageUpdateTimeout);
                self.layoutPageUpdateTimeout = null;
            }
        }

        // switch publisher on existing.pause others.
        function onLayoutPageSubscriberChange(enabling, disabling, reason) {
            var data = self.layoutPageData;
            var data1 = self.layoutPageReuse;

            // pair a disabling with enabling fid, and use switch.
            // if more enabling, find plugins that are paused.
            // if more disabling, pause some plugins.

            // update visible attribute first.
            enabling.forEach(function (fid) {
                var div = data.videos[fid].div;
                if (div) {
                    div.removeAttribute('visible');
                }
            });
            disabling.forEach(function (fid) {
                var item = data.videos[fid];
                var div = item.div;
                if (div && !item.visible) {
                    div.setAttribute('visible', 'false');
                }
            });

            // set of items that are getting enabled.
            enablingDict = {};
            enabling.forEach(function (fid0) {
                enablingDict[fid0] = true;
            });

            // rest of the algorithm is only for remote videos.
            enabling = enabling.filter(function (fid) {
                return !!((data.videos[fid] || {}).div || {}).remoteFeed;
            });
            disabling = disabling.filter(function (fid) {
                return !!((data.videos[fid] || {}).div || {}).remoteFeed;
            });
            if (!enabling.length && !disabling.length) {
                self.logLayout('nothing to enable or disable');
                return;
            }

            self.logLayout('remote feeds enabling=' + enabling.length + ' disabling=' + disabling.length);

            var status = [];
            if (self.testvideos) {
                self.logLayout(
                    'before: ',
                    data1.wrappers
                        .filter(function (feed) {
                            return feed._plugin;
                        })
                        .map(function (feed) {
                            return ('' + feed._fid).split(':')[1] + (feed.layoutHidden ? '(H)' : '');
                        })
                        .join(',')
                );
            }

            // for each video to be enabled, if plugin not found, then find a video to be disabled with plugin.
            // if found, then switch from one to another.
            // if plugin already found but hidden, then use that to switch,
            // if video not found, then create new plugin (TODO).
            // for each video to be disabled, mark the video as hidden.

            disabling1 = disabling
                .map(function (fid) {
                    // feeds with plugin that are not detaching and will not restart.
                    return ((data.videos[fid] || {}).div || {}).remoteFeed;
                })
                .filter(function (feed) {
                    // has plugin and is not content share.
                    return !!feed._plugin && !feed.detaching && !feed.isScreen;
                });
            disabling2 = disabling1.filter(function (feed) {
                // filter only with no pendingCount and has plugin.
                return !feed._pendingCount;
            });

            var foundPlugins = disabling1.length - disabling2.length; // count of feeds with plugins available, but have pendingCount.

            var willSwitch = {}; // fid that are in disabling, but will be reused.
            var toCreate = []; // feeds that should be enabled but did not find existing plugin to use.

            enabling.forEach(function (fid0, index) {
                var item0 = data.videos[fid0];
                var div0 = item0 ? item0.div : null;
                var item1 = null,
                    div1 = null;
                if (div0 && div0.remoteFeed) {
                    if (div0.remoteFeed._plugin || div0.remoteFeed.isScreen) {
                        // plugin found. start.
                        status.push('starting ' + fid0);
                        delete div0.remoteFeed.layoutHidden;
                        self.pauseVideoPlay(div0.remoteFeed, false);
                        self.simulcastReason = 'onLayoutPageSubscriberChange starting subscriber';
                        self.setSimulcast(div0); // explicitly fix simulcast, as last value may be incorrect.
                    } else {
                        // plugin not found. use from disabling2.
                        var fid1 = disabling2.length > 0 ? disabling2.shift()._fid : null;
                        if (fid1) {
                            willSwitch[fid1] = true; // so that this feed is not paused later.
                        } else {
                            // if not in disabling2, then try from others hidden.
                            // find all other wrappers with valid plugin, hidden, not detaching and not enabling.
                            var items1 = data1.wrappers.filter(function (feed) {
                                return (
                                    feed._plugin &&
                                    feed.layoutHidden &&
                                    !feed.detaching &&
                                    enablingDict[feed._fid] === undefined
                                );
                            });
                            var items = items1.filter(function (feed) {
                                // filter only with no pendingCount.
                                return !feed._pendingCount;
                            });
                            foundPlugins += items1.length - items.length; // count includes feeds with available plugins, but have pendingCount.

                            fid1 = items.length > 0 ? items[0]._fid : null;
                            item1 = fid1 ? data.videos[fid1] : null;
                            div1 = item1 ? item1.div : null;
                            if (div1 && div1.remoteFeed) {
                                // start again.
                                self.pauseVideoPlay(div1.remoteFeed, false);
                            } else {
                                fid1 = null; // assume not found, if div or feed are not set.
                            }
                        }
                        if (!fid1) {
                            if (div0 && div0.remoteFeed) {
                                var max = Math.max(data.cutoff, data.pageSize);
                                self.logLayout(
                                    'creating new plugin, count=' + data1.count + ', max=' + max + ', fid=' + fid0
                                );
                                toCreate.push(div0.remoteFeed);
                            } else {
                                logger.error('onLayoutPageSubscriberChange', 'no plugin found for enabling', fid0);
                            }
                            return;
                        }

                        // replacement was found, so use switch to switch the publisher on the replacement's existing plugin.
                        status.push('switch ' + fid1 + ' to ' + fid0 + (!willSwitch[fid1] ? ' (restart)' : ''));
                        item1 = data.videos[fid1];
                        div1 = item1 ? item1.div : null;
                        if (div1 && div1.remoteFeed) {
                            self.layoutPageSubscriberSwitch(div0, div1, reason);
                            self.simulcastReason = 'onLayoutPageSubscribeChange switching';
                            self.setSimulcast(div0); // explicitly fix simulcast.
                        }
                    }
                } else {
                    self.logLayout('remoteFeed is not set yet, ignored enabling for fid=' + fid0);
                }
            });

            disabling.forEach(function (fid1) {
                if (!willSwitch[fid1]) {
                    var item1 = data.videos[fid1];
                    var div1 = item1 ? item1.div : null;
                    status.push('pausing ' + fid1);
                    if (div1 && div1.remoteFeed) {
                        div1.remoteFeed.layoutHidden = true;
                        if (div1.remoteFeed._plugin || div1.remoteFeed.isScreen) {
                            self.pauseVideoPlay(div1.remoteFeed, true);
                        }
                    }
                }
            });

            // TODO: if foundPlugins is valid, then check after brief timeout if something became available, instead of creating new.

            if (toCreate.length > 0) {
                self.msgflowEvent('play-attach:change', {
                    id: toCreate.map(function (wrapper) {
                        return wrapper._fid;
                    })
                });
            }
            toCreate.forEach(function (wrapper) {
                // create new plugins.
                delete wrapper.layoutHidden;
                self.layoutPageSubscriberAttach(wrapper);
            });

            if (self.testvideos) {
                self.logLayout(
                    'after:  ',
                    data1.wrappers
                        .filter(function (feed) {
                            return feed._plugin;
                        })
                        .map(function (feed) {
                            return ('' + feed._fid).split(':')[1] + (feed.layoutHidden ? '(H)' : '');
                        })
                        .join(',')
                );
            }
            self.logLayout('status=\n' + status.join('\n'));
        }

        // perform switch to new div0 from previous div1 video feed.
        function layoutPageSubscriberSwitch(div0, div1, reason) {
            var data = self.layoutPageData;

            var feed0 = div0.remoteFeed,
                feed1 = div1.remoteFeed;
            var video0 = div0.querySelector('video'),
                video1 = div1.querySelector('video');

            if (feed0.isScreen || feed1.isScreen) {
                logger.error(
                    'layoutPageSubscriberSwitch',
                    'videoroomCtrl - invalid switch involving content fid ' +
                        div0.getAttribute('user') +
                        ',' +
                        feed0.isScreen +
                        ' to ' +
                        div1.getAttribute('user') +
                        ',' +
                        feed1.isScreen
                );
            }

            var plugin = feed1._plugin;
            var stream = video1.srcObject;
            feed1._plugin = null;
            if (div1 !== div0) {
                self.logLayout(
                    'subscriber switch to ' + (feed0 ? feed0._fid : 'null') + ' from ' + (feed1 ? feed1._fid : 'null')
                );
                // resetting srcObject will cause video to turn black during switch/animation. delay briefly if animation enabled.
                // flip is a special case, because multiple flips are queued, and resetting srcObject now or
                // after a fixed timeout, does not work. In that case let the caller reset on completion.
                if (div0.resetSrcObject) {
                    delete div0.resetSrcObject;
                    try {
                        video0.srcObject = null;
                    } catch (err) {}
                }
                if (div1.resetSrcObject) {
                    delete div1.resetSrcObject;
                    try {
                        video1.srcObject = null;
                    } catch (err) {}
                }

                if (reason == 'flip' && data.animateFlip) {
                    div1.resetSrcObject = true;
                    video1.pause();
                } else if (reason != 'flip' && data.animateGoto) {
                    video1.pause();
                    // there is a danger if video1.srcObject is re-assigned before 250ms, causing issue.
                    div1.resetSrcTimer = $timeout(function () {
                        delete div1.resetSrcTimer;
                        video1.srcObject = null;
                    }, 250);
                } else {
                    video1.srcObject = null;
                }
            }

            delete feed0.layoutHidden;
            feed0._plugin = plugin; // TODO: check for duplicate.
            plugin._wrapper = feed0;

            // copy attributes and properties that are dependent on plugin state.
            if (feed0 !== feed1) {
                feed0.simulcastStarted = feed1.simulcastStarted;

                if (feed0.iceRestartTimer) {
                    logger.error('layoutPageSubscriberSwitch', 'iceRestartTimer was already set for feed0', feed0._fid);
                }
                if (feed1.iceRestartTimer) {
                    var timer0 = (feed0.iceRestartTimer = feed1.iceRestartTimer);
                    delete feed1.iceRestartTimer;
                    if (timer0._internal) {
                        timer0._internal.context = feed0;
                        timer0._internal.arg = feed0._fid; // Do not set to feed1.iceRestartArg;
                    }
                }

                if (div0.timerSimulcast1) {
                    logger.error('layoutPageSubscriberSwitch', 'timerSimulcast1 was already set for div0', feed0._fid);
                    self.layoutPageTimeoutCancelWithState(div0.timerSimulcast1);
                }
                if (div1.timerSimulcast1) {
                    var timer1 = (div0.timerSimulcast1 = div1.timerSimulcast1);
                    delete div1.timerSimulcast1;
                    if (timer1._internal) {
                        timer1._internal.div = div0;
                    }
                }

                if (div0.timerSimulcast2) {
                    logger.error('layoutPageSubscriberSwitch', 'timerSimulcast2 was already set for div0', feed0._fid);
                    self.layoutPageTimeoutCancelWithState(div0.timerSimulcast2);
                }
                if (div1.timerSimulcast2) {
                    var timer2 = (div0.timerSimulcast2 = div1.timerSimulcast2);
                    delete div1.timerSimulcast2;
                    if (timer2._internal) {
                        timer2._internal.div = div0;
                    }
                }

                if (div0.pendingSimulcast) {
                    delete div0.pendingSimulcast;
                }
                if (div1.pendingSimulcast) {
                    div0.pendingSimulcast = div1.pendingSimulcast;
                    delete div1.pendingSimulcast;
                }

                if (div0.slowLinkTimer) {
                    logger.error('layoutPageSubscriberSwitch', 'slowLinkTimer was already set for div0', feed0._fid);
                    self.layoutPageTimeoutCancelWithState(div0.slowLinkTimer);
                }
                if (div1.slowLinkTimer) {
                    var timer3 = (div0.slowLinkTimer = div1.slowLinkTimer);
                    delete div1.slowLinkTimer;
                    if (timer3._internal) {
                        timer3._internal.div = div0;
                    }
                }
                if (div1.slowLinkCount) {
                    div0.slowLinkCount = div1.slowLinkCount;
                    delete div1.slowLinkCount;
                } else {
                    delete div0.slowLinkCount;
                }

                if (feed0.state && feed1.state) {
                    feed0.state.call = feed1.state.call;
                    feed0.state.webrtc = feed1.state.webrtc;
                    feed0.state.ice = feed1.state.ice;
                    feed0.state.media = feed1.state.media;
                    // do not copy video and startTime.
                    delete feed1.state.call;
                    delete feed1.state.webrtc;
                    delete feed1.state.ice;
                    delete feed1.state.media;
                }

                var videoTrack = stream && stream.getVideoTracks()[0];
                if (videoTrack && videoTrack._internal) {
                    videoTrack._internal.div = div0;
                    videoTrack._internal.fid = div0.remoteFeed._fid;
                } else {
                    self.logLayout('switched feed is same, so not changing');
                }
            }

            if (div0 !== div1) {
                ['temporal', 'substream', 'simulcast', 'playing'].forEach(function (attr) {
                    if (div1.hasAttribute(attr)) {
                        div0.setAttribute(attr, div1.getAttribute(attr));
                    } else {
                        div0.removeAttribute(attr);
                    }
                });
            } else {
                self.logLayout('switched div is same, so not changing');
            }

            if (div0.getAttribute('enable') == 'false') {
                div0.setAttribute('enable', 'true'); // so that setSimulcast works with right substream instead of 0,0
            }

            if (self.isCompactMode) {
                //div0.querySelector('video').play();
                if (div1 !== div0) {
                    self.layoutPageCancelResetSrcObject(div0);
                    video0.srcObject = stream;
                }
            }

            // actually send the switch request.
            feed0.send({ message: { request: 'switch', feed: feed0._feed, substream: 0, temporal: 0 } });

            if (!self.isCompactMode) {
                //div0.querySelector('video').play();
                if (div1 !== div0) {
                    self.layoutPageCancelResetSrcObject(div0);
                    video0.srcObject = stream;
                }
            }
        }

        // flip process had delayed this reset to after animation.
        function layoutPageResetSrcObjectIfNeeded(div) {
            if (self.layoutPage && self.layoutPageReuse.enabled) {
                if (div.resetSrcObject) {
                    delete div.resetSrcObject;
                    try {
                        div.querySelector('video').srcObject = null;
                    } catch (err) {} // ignore
                }
            }
        }

        // cancel reset of srcObject timer, and do reset if needed.
        function layoutPageCancelResetSrcObject(div, doReset) {
            if (self.layoutPage && self.layoutPageReuse.enabled) {
                if (div.resetSrcTimer) {
                    // do not reset srcObject anymore.
                    $timeout.cancel(div.resetSrcTimer);
                    delete div.resetSrcTimer;
                    if (doReset) {
                        try {
                            div.querySelector('video').srcObject = null;
                        } catch (err) {}
                    }
                }
            }
        }

        // create timer with internal state saved and restored if reuse enabled,
        // as those attached to plugin may change.
        function layoutPageTimeoutWithState(state, callback, timeout) {
            if (self.layoutPage && self.layoutPageReuse.enabled) {
                var timer = $timeout(function () {
                    self.logLayout('wrapper timer triggered', state);
                    var state = timer._internal;
                    delete timer._internal;

                    callback(state);
                }, timeout);

                timer._internal = state;
                return timer;
            } else {
                return $timeout(function () {
                    callback(state);
                }, timeout);
            }
        }

        // remove internal state from timer if needed.
        function layoutPageTimeoutCancelWithState(timer) {
            $timeout.cancel(timer);

            if (self.layoutPage && self.layoutPageReuse.enabled && timer && timer._internal) {
                delete timer._internal;
            }
        }

        // if reuse enabled, save restore internal state as those attached to track may change.
        function layoutPageVideoMuteUnmuteListener(videoTrack, state, callback) {
            if (self.layoutPage && self.layoutPageReuse.enabled) {
                videoTrack._internal = state;
                videoTrack.addEventListener('mute', function (event) {
                    var state = event.currentTarget._internal;
                    callback(state, event);
                });
                videoTrack.addEventListener('unmute', function (event) {
                    var state = event.currentTarget._internal;
                    callback(state, event);
                });
            } else {
                videoTrack.addEventListener('mute', function (event) {
                    callback(state, event);
                });
                videoTrack.addEventListener('unmute', function (event) {
                    callback(state, event);
                });
            }
        }

        function layoutPagePendingTimerStart(duration) {
            var data1 = self.layoutPageReuse;
            self.layoutPagePendingTimerStop();
            data1.pendingTimeout = $timeout(self.layoutPagePendingTimerHandler, duration || data1.pendingWaitTime);
        }

        function layoutPagePendingTimerStop() {
            var data1 = self.layoutPageReuse;
            if (data1.pendingTimeout) {
                $timeout.cancel(data1.pendingTimeout);
                data1.pendingTimeout = null;
            }
        }

        function layoutPagePendingTimerHandler() {
            var data1 = self.layoutPageReuse;

            if (data1.pendingStart > 0 || data1.pendingCreate.length > 0) {
                logger.error(
                    'layoutPagePendingTimerHandler',
                    'pending timer expired, pendingStart=' +
                        data1.pendingStart +
                        ' pendingCreate.length=' +
                        data1.pendingCreate.length
                );
            } else {
                self.logLayout('pending timer expires, but nothing to do');
            }

            data1.pendingTimeout = null;

            if (data1.pendingStart > 0) {
                // remove pending start flag from existing wrappers, and attempt restart play.
                data1.pendingStart = 0;
                if (data1.pendingStartId.length > 0) {
                    self.logLayout('deleting pendingStartId of ' + data1.pendingStartId.join(', '));
                    data1.pendingStartId.splice(0, data1.pendingStartId.length);
                }
                var toRestart = [];
                data1.wrappers.forEach(function (wrapper) {
                    if (wrapper._callbacks && wrapper._callbacks._pendingStart) {
                        delete wrapper._callbacks._pendingStart;
                        toRestart.push(wrapper);
                    }
                });
                toRestart.forEach(function (wrapper) {
                    self.msgflowEvent('play-restart:check', { reason: 'after layout check', id: wrapper._fid });
                    self.restartVideoPlay(wrapper._fid);
                });
            }

            if (data1.pendingStart <= 0 && data1.pendingCreate.length > 0) {
                // attach the first subscriber without checking data1.count < max. it will create a chain.
                self.logLayout('doing actual attach on timer, count=' + data1.count);
                var wrapper0 = data1.pendingCreate.shift();
                self.msgflowEvent('play-attach:timeout:' + wrapper0._fid, {
                    reason: 'after pending timeout',
                    id: wrapper0._fid
                });
                self.layoutPageSubscriberAttach(wrapper0);
            }
        }

        function onLayoutPageUpdateComplete() {
            if (self.layoutPageUpdateTimeout) {
                $timeout.cancel(self.layoutPageUpdateTimeout);
                self.layoutPageUpdateTimeout = null;
            }

            self.layoutPageUpdateTimeout = $timeout(function () {
                self.layoutPageUpdateTimeout = null;
                self.layoutPageVerifyInvariants(true, true);
            }, self.layoutPageUpdateAfter);
            if (self.isCompactMode) {
                self.compactAddExitOnClick();
            }
        }

        function layoutPageVerifyInvariants(restart, concise) {
            // verify all invariants.

            var data = self.layoutPageData;
            var data1 = self.layoutPageReuse;

            var errors = [];
            var max = Math.max(data.cutoff, data.pageSize);
            if (data1.plugins.length > max * 1.2) {
                // more than 20% of max.
                errors.push('too many plugins count=' + data1.plugins.length);
            }
            if (data1.plugins.length != data1.count) {
                errors.push('mismatch in plugins count ' + data1.plugins.length + '!=' + data1.count);
            }
            if (data1.pendingStart) {
                var pendingId = concise
                    ? []
                    : data1.wrappers
                          .filter(function (wrapper) {
                              return !!wrapper._callbacks._pendingStart;
                          })
                          .map(function (wrapper) {
                              return '' + wrapper._fid;
                          });
                errors.push(
                    'pending start is ' +
                        data1.pendingStart +
                        (concise
                            ? ''
                            : ' [' +
                              data1.pendingStartId.length +
                              ':' +
                              data1.pendingStartId.join(',') +
                              ']' +
                              '[' +
                              pendingId.length +
                              ':' +
                              pendingId.join(',') +
                              ']')
                );

                if (data1.pendingStart > 0 && !pendingId.length) {
                    logger.error(
                        'layoutPageVerifyInvariants',
                        'restarting pending timer because pendingStart is ' +
                            data1.pendingStart +
                            ' but no wrapper found pending'
                    );
                    self.layoutPagePendingTimerStart(100);
                }
            }
            if (data1.pendingCreate.length) {
                var pendingCreate = concise
                    ? ''
                    : data1.wrappers.map(function (wrapper) {
                          return '' + wrapper._fid;
                      });
                errors.push(
                    'pending create is ' + pendingCreate.length + (concise ? '' : ' [' + pendingCreate.join(',') + ']')
                );
            }
            var wrappers = {}; // fid to list of wrapper objects. needed to handle duplicate fid.
            var detaching = [];
            var now = Date.now();
            data1.wrappers.forEach(function (wrapper) {
                if (wrapper._detachingTime) {
                    // ignore if detaching
                    if (!concise && wrapper._callbacks) {
                        var diff = Math.floor((now - wrapper._detachingTime) / 1000);
                        detaching.push(wrapper._callbacks._pendingId + '/' + wrapper._fid + '/' + diff + 's');
                    }
                    return;
                }
                var fid = wrapper._fid;
                if (wrappers[fid] === undefined) {
                    wrappers[fid] = [];
                }
                wrappers[fid].push(wrapper);
            });

            if (detaching.length > 0) {
                errors.push('detaching count ' + detaching.length + (concise ? '' : '[' + detaching.join(',') + ']'));
            }

            var missingPlugins = [],
                missingItems = [];
            for (var fid1 in wrappers) {
                var list = wrappers[fid1];
                var item = data.videos[fid1];
                if (item) {
                    if (item.visible) {
                        // if visible but no plugin in list, then restart
                        if (
                            list.filter(function (wrapper) {
                                return !!wrapper._plugin;
                            }).length == 0
                        ) {
                            missingPlugins.push(fid1);
                        }
                    }
                } else {
                    missingItems.push(fid1);
                }
            }

            if (missingPlugins.length > 0) {
                errors.push(
                    'missing plugin for visible count ' +
                        missingPlugins.length +
                        (concise ? '' : ' [' + missingPlugins.join(',') + ']')
                );
            }
            if (missingItems.length > 0) {
                errors.push(
                    'missing video item count ' +
                        missingItems.length +
                        (concise ? '' : '[' + missingItems.join(',') + ']')
                );
            }
            if (!concise) {
                // list frozen video items
                var frozenItems = $window.$(
                    '#videoroom-videos > div[user][enable="true"][playing="false"]:not(.audioonly)'
                );
                if (frozenItems.length > 0) {
                    errors.push(
                        'frozen video item count ' +
                            frozenItems.length +
                            '[' +
                            frozenItems
                                .map(function (index, item) {
                                    return item.getAttribute('user');
                                })
                                .get()
                                .join(',') +
                            ']'
                    );
                }
            }
            if (errors.length > 0) {
                logger.error(
                    'layoutPageVerifyInvariants',
                    'videoroomCtrl - layoutReuse errors [' +
                        errors.length +
                        ']: ' +
                        errors.join('; ') +
                        (concise
                            ? ''
                            : ' [items ' +
                              Object.keys(data.videos).length +
                              ', boxes ' +
                              $window.$('#videoroom-videos > div[user]:not(.audioonly)').length +
                              ', videos ' +
                              data.videoCount +
                              ', slots ' +
                              data.slots.length +
                              ', ordered ' +
                              data.ordered.length +
                              ']')
                );
            }
            if (restart && data1.enableWrapper && missingPlugins.length > 0) {
                self.logLayout('restarting video play due to missing plugin, count=' + missingPlugins.length);
                self.msgflowEvent('play-restart:missing', { reason: 'missing plugins', id: missingPlugins });
                missingPlugins.forEach(function (fid) {
                    self.restartVideoPlay(fid);
                });
            }
            return errors;
        }

        // printable state object.
        function getLayoutPageState() {
            if (!self.layoutPage) {
                return {};
            }
            var videos = Object.entries(self.layoutPageData.videos).map(function (entry) {
                var key = entry[0],
                    value = entry[1];
                return [key, Object.assign({}, value, { div: !!(value && value.div) })];
            });
            var wrappers = self.layoutPageReuse.wrappers.map(function (item) {
                return Object.assign(
                    {},
                    {
                        _pendingId: item._callbacks && item._callbacks._pendingId,
                        _state: item.state,
                        _fid: item._fid,
                        _feed: item._feed,
                        _plugin: !!item._plugin,
                        rfdisplay: item.rfdisplay,
                        isScreen: item.isScreen
                    }
                );
            });
            var plugins = self.layoutPageReuse.plugins.map(function (item) {
                return Object.assign(
                    {},
                    {
                        _pendingId: item._pendingId,
                        _pendingCount: item._pendingCount,
                        detached: item.detached,
                        id: item.id,
                        _wrapper: !!item._wrapper
                    }
                );
            });
            console.log(videos, wrappers, plugins);
            return {
                layoutPage: Object.assign({}, self.layoutPageData, { videos: videos }),
                layoutPageReuse: Object.assign({}, self.layoutPageReuse, { plugins: plugins, wrappers: wrappers })
            };
        }
    }
]);
